import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import MagazinePage from './pages/MagazinePage';
import PortalPusah from './pages/PortalPusah';
import InstitucionNoEncontrada from './pages/InstitucionNoEncontrada';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import PrivateRoute from './components/PrivateRoute';
import { PantallaCarga, PantallaError } from './components/PantallaCarga';
import { AuthProvider } from './context/AuthContext';
import { InstitucionProvider, useInstitucion } from './context/InstitucionContext';
import { getDefaultMagazineId } from './config/magazineConfig';

// Las rutas dependen del modo del tenant:
//  - dominio:    /  /:categoryId  /:categoryId/:magazineId
//  - plataforma: /  (portal)  /:institucion  /:institucion/:categoryId  /:institucion/:categoryId/:magazineId
// El host determina un único modo, así que las dos familias nunca conviven. Las rutas de
// administración van siempre primero porque /:categoryId (o /:institucion) es un catch-all.
const Rutas = () => {
  const { modo, institucion, cargando, error, recargar } = useInstitucion();

  if (cargando) return <PantallaCarga />;
  if (error) return <PantallaError mensaje={error} onReintentar={recargar} />;

  const plataforma = modo === 'plataforma';
  const p = plataforma ? '/:institucion' : '';
  // Ruta de compatibilidad /viewer (catálogo legado): sólo en modo dominio.
  const defaultMagazine = !plataforma && institucion ? getDefaultMagazineId(institucion.slug) : null;

  return (
    <Switch>
      {/* --- Módulo administrador (debe ir ANTES de las rutas con parámetro) --- */}
      <Route exact path="/admin/login" component={AdminLogin} />
      <PrivateRoute path="/admin" component={AdminLayout} />

      {/* Host de plataforma sin institución en la ruta: portal de instituciones */}
      {plataforma && <Route exact path="/" component={PortalPusah} />}

      {/* El primer segmento no corresponde a ninguna institución activa */}
      {plataforma && !institucion && <Route path="/:institucion" component={InstitucionNoEncontrada} />}
      {!plataforma && !institucion && <Route path="*" component={InstitucionNoEncontrada} />}

      {defaultMagazine && (
        <Route path="/viewer">
          <Redirect to={`/${defaultMagazine.categoryId}/${defaultMagazine.magazineId}`} />
        </Route>
      )}

      {/* Página principal - Centro de Publicaciones */}
      <Route exact path={`${p}/`} component={HomePage} />

      {/* Página de categoría - subcategorías o publicaciones */}
      <Route exact path={`${p}/:categoryId`} component={CategoryPage} />

      {/* Visor de publicación */}
      <Route path={`${p}/:categoryId/:magazineId`} component={MagazinePage} />

      {/* Ruta 404: redirigir al inicio */}
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL}>
        {/* Dentro del Router: necesita la ruta para saber la institución en modo plataforma */}
        <InstitucionProvider>
          <Rutas />
        </InstitucionProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
